import React, { useEffect, useState, useRef } from "react";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const CelebrationPopup = () => {
  const [popupData, setPopupData] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [confettiItems, setConfettiItems] = useState([]);
  //   const [audio, setAudio] = useState(null);
  const audioRef = useRef(null); // Use ref to hold audio

  function getRandomString(arr) {
    if (arr.length === 0) return null; // Handle empty array case
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
  }

  const createConfetti = () => {
    const colors = ["#e91e63", "#3f51b5", "#ff9800", "#4caf50"];
    const confetti = [];
    for (let i = 0; i < 100; i++) {
      confetti.push({
        id: Date.now() + Math.random(),
        left: Math.random() * 100,
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: Math.random() * 4,
      });
    }
    setConfettiItems(confetti);
    setTimeout(() => setConfettiItems([]), 8000); // 3 sec fade-out
  };

  useEffect(() => {
    // Run once immediately
    createConfetti();

    // Then repeat every 10 sec
    const interval = setInterval(createConfetti, 10000);

    return () => clearInterval(interval); // cleanup
  }, []);

  //   const startCelebration = (audioSrc) => {
  //     if (audioSrc) {
  //       const sound = new Audio(audioSrc);
  //       sound.loop = true;
  //       sound
  //         .play()
  //         .then(() => console.log("Playing celebration audio"))
  //         .catch((err) => console.warn("Audio play failed:", err));
  //       setAudio(sound);
  //       setIsVisible(true);
  //     }
  //     createConfetti();
  //   };

  //   const stopCelebration = () => {
  //     if (audio) {

  //       audio.pause();
  //       audio.currentTime = 0;
  //     }
  //     setConfettiItems([]);
  //     setIsVisible(false);
  //   };

  const startCelebration = (audioSrc) => {
    if (audioSrc) {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
      const sound = new Audio(audioSrc);
      sound.loop = true;
      sound.play().catch((err) => console.warn("Audio play failed:", err));
      audioRef.current = sound; // Save audio to ref
      setIsVisible(true);
    }
    createConfetti();
  };

  const stopCelebration = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
    }
    setConfettiItems([]);
    setIsVisible(false);
  };

  useEffect(() => {
    const checkPopup = () => {
      performRequest("GET", "/celebration/getCelebrtation/")
        .then((res) => {
          if (res.status === 200 && res.data?.data) {
            setPopupData(res.data.data);

            const strings = [
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751967303/achievement-short-version-170836_lh6x3v.mp3",
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751967296/innovation-and-achievement-corporate-289531_wn7rzl.mp3",
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751967288/successful-cheerful-uplifting-positive-achievement-motivational-music-16529_v1crql.mp3",
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751967283/winning-elevation-111355_bhueaz.mp3",
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751967265/your-achievement-295633_cq2v5v.mp3",
              "https://res.cloudinary.com/bsgfcooa/video/upload/v1751967241/achievement-short-version-170836_aebaeo.mp3",
            ];

            startCelebration(getRandomString(strings));

            setTimeout(stopCelebration, res.data?.data?.duration * 60 * 1000);
          }
        })
        .catch((err) => {
          console.error("Error fetching popup:", err);
          CustomErrorResponse(err);
        });
    };

    checkPopup(); // Run immediately
    const interval = setInterval(checkPopup, 30 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {isVisible && popupData && (
        <div
          className="modal show"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 1000,
            position: "fixed",
            top: 0,
            left: 0,
            // width: "100%",
            // height: "100%",
            width: "100vw",
            height: "100vh",
          }}
        >
          <div
            className="modal-dialog modal-xl modal-dialog-centered"
            role="document"
          >
            <div
              className="modal-content"
              style={{
                background: "linear-gradient(135deg, #fff0f6, #ffe4ec)",
                borderRadius: "20px",
                padding: "30px",
                boxShadow: "0 15px 40px rgba(0,0,0,0.3)",
                border: "4px solid #ff69b4",
                position: "relative",
                overflow: "hidden",
                animation: "popupScale 0.4s ease-out",
                width: "100vw",
                height: "500px",
                // display
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                margin: "",
              }}
            >
              <div className="modal-body text-center d-flex flex-column justify-content-center align-items-center w-100">
                <div className="">
                  {/* Confetti */}
                  {confettiItems.map((item) => (
                    <div
                      key={item.id}
                      style={{
                        position: "absolute",
                        top: "-20px",
                        left: `${item.left}%`,
                        fontSize: "1.5rem",
                        animation: `fall 5s linear ${item.delay}s forwards`,
                      }}
                    >
                      {["🎉", "🎈", "🥳", "🎊"][Math.floor(Math.random() * 4)]}
                    </div>
                  ))}
                  <h2
                    style={{
                      fontSize: "4rem",
                      color: "#d63384",
                      fontFamily: "'Comic Sans MS', cursive",
                      fontWeight: "bold",
                      marginBottom: "15px",
                      textShadow: "2px 2px 5px rgba(0,0,0,0.15)",
                    }}
                  >
                    🎉 {popupData.name} 🎉
                  </h2>
                  <br></br>

                  <p
                    style={{
                      fontSize: "3rem",
                      color: "#444",
                      fontFamily: "'Trebuchet MS', sans-serif",
                      marginBottom: "20px",
                      lineHeight: "1.5",
                    }}
                  >
                    {popupData.description} 🥳
                  </p>

                  {/* <small
                    style={{
                      fontSize: "1.2rem",
                      color: "#fff",
                      backgroundColor: "#ff69b4",
                      padding: "5px 12px",
                      borderRadius: "12px",
                      boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
                    }}
                  >
                    ⏰ Scheduled at: {popupData.time}
                  </small> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>
        {`
        @keyframes fall {
          to {
            transform: translateY(600px) rotate(360deg);
            opacity: 0;
          }
        }
        @keyframes popupScale {
          from {
            transform: scale(0.7);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}
      </style>
    </>
  );
};

export default CelebrationPopup;
